import { useState } from "react";
import { Store } from '../../../types';
import StoreItem from './StoreItem';

type Props =
    {
        store: Store,
        sync: (store: Store) => any
    }


export default function StoreItemContainer({ store, sync }: Props) {
    const [error, setError] = useState<undefined | string>();

    const syncStore: () => Promise<void> = async () => {
        const error = await sync(store);

        if (error === "") {
            setError("");
        }

        else setError(error);
    }

    return (
        <div>
            <StoreItem store={store} error={error} syncStore={syncStore}></StoreItem>
        </div>
    )
}